import { Flex, Notice } from '@applyboard/crystal-ui'
import { PolicyEvaluationResult } from './types'

interface PolicyBannerProps {
  evaluation: PolicyEvaluationResult
  intakeTerm?: string
}

export function PolicyBanner({ evaluation, intakeTerm }: PolicyBannerProps) {
  const hasViolations =
    evaluation.violations?.some(
      violation => violation.code === 'MAX_ACTIVE_APPLICATIONS_EXCEEDED',
    ) ?? false

  if (!hasViolations) {
    return null
  }

  return (
    <Flex>
      <Notice intent="warning">
        {`This application cannot be submitted. The ${intakeTerm || 'intake'} application limit has been reached. Change the intake to be able to submit.`}
      </Notice>
    </Flex>
  )
}
